import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { Radio, Table, TableBody, TableCell, TableHead, TableRow, withStyles, } from "@material-ui/core";
import APIService from '../../../apis/amplify/APIService';
import { receive_appointment_hour_slot, receive_availabilitySlots } from "../../../apis/redux/fetchActions";
import SectionTitleContainer, { SectionTitle } from "../../../components/SectionTitleContainer";
import Adaptable from "../../../components/Adaptable";
import If from "../../../components/If";
import Loading, { LoadingText, Progress } from "../../../components/Loading";
import { errorBundaryHOC } from "../../../components/ErrorBoundary";
import { styles } from './styles'

const dayName = ["Sun", "Mon", "Tue", "Wed", 'Thu', "Fri", "Sat"];

function transformAvailability(apiResponse) {
    const {availability} = apiResponse;
    if (!availability) {
        return null;
    }

    let daysInfo = {ids: [], byId: {}};
    let timeRangesInfo = {ids: [], byId: {}};
    let schedulesInfo = {};
    let scheduleCid = 1;
    availability.forEach(dayAvailable => {
        const {date: dayId, hour_slots: hourSlots = []} = dayAvailable;
        daysInfo.ids.push(dayId);
        const {date} = dayAvailable;
        let timeStamp = new Date(date);
        daysInfo.byId[dayId] = {
            id: date,
            date,
            dayInWeek: timeStamp.getDay(),
            dayInMonth: timeStamp.getDate()
        };
        hourSlots.forEach(hs => {
            if (!timeRangesInfo.byId[hs.id]) {
                timeRangesInfo.ids.push(hs.id);

                const {id, name} = hs;
                let [rangeStart, rangeEnd] = name.split('-');
                timeRangesInfo.byId[hs.id] = {id, rangeStart: rangeStart.trim(), rangeEnd: rangeEnd.trim()};
            }
            schedulesInfo[hs.id] = schedulesInfo[hs.id] || [];
            schedulesInfo[hs.id].push({
                cid: scheduleCid,
                dayId,
                timeRangeId: hs.id,
                available: hs.available
            });
            scheduleCid += 1;
        })
    });
    return {
        daysInfo, timeRangesInfo, schedulesInfo
    }
}

class ScheduleAppointmentStep extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            selectedSlotId: null,
        }
    }

    componentDidMount() {
        const {appointmentData, availability} = this.props;

        if (!availability)
            this.loadAvailability();

        if (appointmentData.appointment_hour_slot_id)
            this.setState({ selectedSlotId: appointmentData.appointment_hour_slot_id });
    }

    getRequestedTime() {
        let result = 0;
        this.props.appointmentData.items.forEach(device => {
            device.issues.forEach(issue => {
                result += issue.estimated_time;
            })
        });
        return result;
    }

    async loadAvailability() {
        this.setState({ loading: true });
        const zipCode = this.props.appointmentData.zipCode;
        const requestedTime = this.getRequestedTime();
        const {ok, data} = await
            APIService.getAppointmentAvailability(zipCode, requestedTime);
        if (ok) {
            this.props.actions.receiveAvailabilitySlots(transformAvailability(data));
        }
        this.setState({loading: false});
    }

    onChange(scheduleInfo) {
        const {availability} = this.props;
        let dayInfo = availability.daysInfo.byId[scheduleInfo.dayId];
        let timeRange = availability.timeRangesInfo.byId[scheduleInfo.timeRangeId];
        let day = `${dayName[dayInfo.dayInWeek]} ${dayInfo.dayInMonth}  ${timeRange.rangeStart} - ${timeRange.rangeEnd}`;
        this.setState({selectedSlotId: scheduleInfo.cid});
        this.props.actions.receiveAppointmentHourSlot({
            date: day,
            aptmHourSlot: scheduleInfo.timeRangeId,
            dayId: scheduleInfo.dayId
        });
    }

    renderAvailabilitySlots() {
        const {availability, classes} = this.props;
        if (availability) {
            const {timeRangesInfo, schedulesInfo} = availability;
            return timeRangesInfo.ids.map((timeRangeId, index) => {
                const range = timeRangesInfo.byId[timeRangeId];
                const slots = schedulesInfo[timeRangeId];
                return (
                    <TableRow key={timeRangeId} style={{ background: (index % 2 === 0) && '#FDF9FC' }}>
                        <TableCell align='center' className="cellEnhancedStyle">
                            <span className={classes.rangeDesktop}>
                                <span>{range.rangeStart}</span> - <span>{range.rangeEnd}</span>
                            </span>
                            <span className={classes.rangeMobile}>
                                <span>{range.rangeStart}</span> <span>{range.rangeEnd}</span>
                            </span>
                        </TableCell>
                        {slots.map((item) => {
                            return (<TableCell key={item.cid} align='center'>
                                <Radio onChange={this.onChange.bind(this, item)}
                                       checked={this.state.selectedSlotId === item.cid}
                                       disabled={!item.available} color='primary'/>
                            </TableCell>);
                        })}
                    </TableRow>
                )
            })
        }
    }

    renderDaysHeader() {
        const {availability} = this.props;
        if (availability) {
            const {daysInfo} = availability;
            return daysInfo.ids.map((item, index) => (
                <TableCell key={index} align='center'
                           className="cellEnhancedStyle">
                    {dayName[daysInfo.byId[item].dayInWeek]} {daysInfo.byId[item].dayInMonth}
                </TableCell>))
        }
    }

    render() {
        const { classes } = this.props;
        return (
            <div>
                <Adaptable as={SectionTitleContainer} hideFromSmallDown>
                    <SectionTitle>Select the Appointment Date</SectionTitle>
                </Adaptable>

                <If condition={this.state.loading}
                    as={Loading} style={{marginTop: 20}}>
                    <Progress/><LoadingText>Loading availability...</LoadingText>
                </If>

                <div className={classes.main}>
                    <Table padding='none' className={classes.scheduleTable}>
                        <TableHead>
                            <TableRow className="daysRow">
                                <TableCell align='center'/>
                                {this.renderDaysHeader()}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.renderAvailabilitySlots()}
                        </TableBody>
                    </Table>
                </div>
            </div>
        )
    }

}

const mapStateToProps = state => ({
    availability: state.availability,
    appointmentData: state.appointmentData,
    appointment_hour_slot_id: state.appointmentData.appointment_hour_slot_id,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        receiveAppointmentHourSlot: receive_appointment_hour_slot,
        receiveAvailabilitySlots: receive_availabilitySlots
    }, dispatch)
});

const ScheduleAppointmentStepStyled = withStyles(styles)(ScheduleAppointmentStep);
export default connect(mapStateToProps, mapDispatchToProps)(errorBundaryHOC(ScheduleAppointmentStepStyled));
